module.exports = __webpack_public_path__ + "statics/img/5.516234f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/technological/5.jpg
// module id = Roxg
// module chunks = 1